import {loginAction} from './login-action';

export default loginAction;